var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-down-button"},[_c('Button',{staticStyle:{"width":"130px"},attrs:{"type":"primary","ghost":"","disabled":_vm.status},on:{"click":_vm.getCode}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }